import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { PermissionEnum } from '@model';
import { AdminResolver } from '@resolver';
import { AdminComponent, AdminModule, LoginComponent, LoginModule, LogoutComponent } from '@view';
import { AdminAuthGuard, LoginAuthGuard } from '../guard';

enum Routing {
  admin = 'admin',
  doc = 'doc',
  logout = 'logout',
  root = '',
}

const routerOptions: ExtraOptions = {
  enableTracing: false,
  onSameUrlNavigation: 'reload',
};

const routes: Routes = [
  {
    canActivate: [AdminAuthGuard],
    component: AdminComponent,
    data: { requiredPermissions: [PermissionEnum.update] },
    // loadChildren: () => import('src/app/view/admin/admin.module').then(m => m.AdminModule),
    path: Routing.admin,
    resolve: { updates: AdminResolver },
  },
  {
    canActivate: [LoginAuthGuard],
    component: LoginComponent,
    path: Routing.root,
    pathMatch: 'full',
  },
  {
    component: LogoutComponent,
    path: Routing.logout,
    pathMatch: 'full',
  },
  {
    path: Routing.doc,
    redirectTo: '/doc/index.html',
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [LoginModule, RouterModule.forRoot(routes, routerOptions), AdminModule],
  providers: [LoginAuthGuard, AdminAuthGuard, AdminResolver],
})
export class CoreRoutingModule {}
